module.exports = __webpack_public_path__ + "img/coverfx4.568d05dc.jpg";